import { VisitorPopUpComponent } from "./VisitorPopUpComponent";
export default VisitorPopUpComponent;